import React, { useState, useRef, useEffect } from 'react';
import './OrganizationSetup.css';

const OrganizationSetup = ({ onComplete }) => {
  const organizationInputRef = useRef(null);
  const [formData, setFormData] = useState({
    organizationName: '',
    industry: '',
    companySize: '',
    role: ''
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    setTimeout(() => {
      if (organizationInputRef.current) {
        organizationInputRef.current.focus();
      }
    }, 200);
  }, []);

  const companySizes = [
    'Up to 100',
    '100 to 500',
    '500 to 5,000',
    '5,000 to 10,000',
    '10,000 to 25,000',
    '25,000 to 1,00,000',
    '1,00,000 and above'
  ];

  const roles = [
    'CEO/CXO/Founder',
    'Human Resources',
    'Managing Managers',
    'People Manager',
    'Individual Contributor'
  ];

  const industries = [
    'Agriculture, Forestry & Fishing',
    'Automotive & Auto Components',
    'Aviation, Aerospace & Defense',
    'Banking & Financial Services',
    'Biotechnology & Pharmaceuticals',
    'Chemicals & Petrochemicals',
    'Construction & Infrastructure',
    'Consumer Goods (FMCG, Durables)',
    'Consulting & Professional Services',
    'E-commerce & Internet Services',
    'Education & EdTech',
    'Energy (Oil, Gas, Renewables)',
    'Engineering, Capital Goods & Industrial Manufacturing',
    'Government, Public Sector & Defense',
    'Healthcare, Hospitals & Diagnostics',
    'Hospitality, Travel & Tourism',
    'Information Technology (IT & ITES)',
    'Insurance',
    'Logistics, Transportation & Warehousing',
    'Media, Entertainment & Publishing',
    'Mining, Metals & Natural Resources',
    'NGOs, Foundations & Not-for-Profits',
    'Real Estate & Construction Services',
    'Retail, Wholesale & Trade',
    'Telecom & Communication Services',
    'Other'
  ];

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onComplete(formData);
  };

  return (
    <div className="organization-setup">
      <div className="setup-container">
        <div className="setup-header">
          <h1>Culture Health Check</h1>
          <p>Help us understand your organization to provide more accurate insights.</p>
        </div>

        <form onSubmit={handleSubmit} className="setup-form">
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="organizationName">Company Name</label>
              <input
                type="text"
                id="organizationName"
                ref={organizationInputRef}
                value={formData.organizationName}
                onChange={(e) => handleInputChange('organizationName', e.target.value)}
                placeholder="Enter your company name"
                className="form-input"
                autoComplete="off"
              />
            </div>

            <div className="form-group">
              <label htmlFor="role">Your Role</label>
              <select
                id="role"
                value={formData.role}
                onChange={(e) => handleInputChange('role', e.target.value)}
                className="form-select"
              >
                <option value="">Select your role</option>
                {roles.map(role => (
                  <option key={role} value={role}>{role}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="industry">Industry</label>
              <select
                id="industry"
                value={formData.industry}
                onChange={(e) => handleInputChange('industry', e.target.value)}
                className="form-select"
              >
                <option value="">Select your industry</option>
                {industries.map(industry => (
                  <option key={industry} value={industry}>{industry}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="companySize">Company Size</label>
              <select
                id="companySize"
                value={formData.companySize}
                onChange={(e) => handleInputChange('companySize', e.target.value)}
                className="form-select"
              >
                <option value="">Select company size</option>
                {companySizes.map(size => (
                  <option key={size} value={size}>{size}</option>
                ))}
              </select>
            </div>
          </div>

          <button
            type="submit"
            className="submit-button"
          >
            Start Assessment
          </button>
        </form>
      </div>
    </div>
  );
};

export default OrganizationSetup;